<div class="p-5">

  <!-- Loading -->
  <div *ngIf="state === 'loading'" class="grid grid-cols-4 gap-4">
    <div *ngFor="let _ of [1,2,3,4]" class="h-20 animate-pulse rounded-lg border border-zinc-200 bg-zinc-50"></div>
  </div>

  <!-- Error -->
  <div *ngIf="state === 'error'" class="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
    Couldn't load the overview.
    <button type="button" (click)="load()" class="ml-2 font-medium underline">Retry</button>
  </div>

  <ng-container *ngIf="state === 'loaded'">

    <!-- KPI strip (live data; no fabricated deltas) -->
    <div class="mb-5 grid grid-cols-4 gap-4">
      <div *ngFor="let kpi of kpis" class="rounded-lg border border-zinc-200 bg-white px-4 py-3">
        <div class="flex items-center justify-between">
          <p class="text-xs text-zinc-500">{{ kpi.label }}</p>
          <lucide-icon [name]="kpi.icon" [size]="14" class="text-zinc-400" [strokeWidth]="1.75"></lucide-icon>
        </div>
        <p class="mt-1 text-2xl font-semibold tabular-nums tracking-tight text-zinc-900">{{ kpi.value }}</p>
        <p *ngIf="kpi.hint" class="mt-1.5 text-xs text-zinc-400">{{ kpi.hint }}</p>
      </div>
    </div>

    <!-- Bottom grid: recent signups + system health -->
    <div class="grid grid-cols-3 gap-4">

      <!-- Recent signups (2/3) -->
      <div class="col-span-2 overflow-hidden rounded-lg border border-zinc-200 bg-white">
        <div class="flex items-center justify-between border-b border-zinc-100 px-4 py-3">
          <h2 class="text-xs font-semibold text-zinc-900">Recent Signups</h2>
          <a routerLink="/users" class="text-xs font-medium text-violet-600 hover:text-violet-700">View all users</a>
        </div>
        <table class="w-full">
          <thead>
            <tr class="border-b border-zinc-100">
              <th class="px-4 py-2 text-left text-[10px] font-semibold uppercase tracking-wide text-zinc-400">User</th>
              <th class="px-4 py-2 text-left text-[10px] font-semibold uppercase tracking-wide text-zinc-400">Plan</th>
              <th class="px-4 py-2 text-left text-[10px] font-semibold uppercase tracking-wide text-zinc-400">Joined</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-zinc-100">
            <tr *ngFor="let u of recentSignups" class="hover:bg-zinc-50">
              <td class="px-4 py-2.5">
                <div class="flex items-center gap-2.5">
                  <div class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-violet-100 text-[10px] font-semibold text-violet-700">
                    {{ u.initials }}
                  </div>
                  <div>
                    <p class="text-xs font-medium text-zinc-900">{{ u.name }}</p>
                    <p class="text-[11px] text-zinc-400">{{ u.email }}</p>
                  </div>
                </div>
              </td>
              <td class="px-4 py-2.5">
                <span class="rounded px-1.5 py-0.5 text-[11px] font-medium capitalize" [ngClass]="tierBadge(u.tier)">
                  {{ u.tier }}
                </span>
              </td>
              <td class="px-4 py-2.5 text-[11px] text-zinc-500">{{ u.joined | date:'MMM d, y' }}</td>
            </tr>
            <tr *ngIf="recentSignups.length === 0">
              <td colspan="3" class="px-4 py-6 text-center text-xs text-zinc-400">No users yet.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- System health (1/3) — from the system-log aggregate -->
      <div class="overflow-hidden rounded-lg border border-zinc-200 bg-white">
        <div class="flex items-center justify-between border-b border-zinc-100 px-4 py-3">
          <h2 class="text-xs font-semibold text-zinc-900">System Health</h2>
          <span *ngIf="health" class="text-[11px] text-zinc-400">last {{ health.windowHours }}h</span>
        </div>

        <div *ngIf="health; else noHealth" class="px-4 py-3">
          <div class="mb-3 flex items-baseline gap-2">
            <span class="text-2xl font-semibold tabular-nums tracking-tight"
                  [class.text-emerald-600]="health.errorCount === 0"
                  [class.text-red-600]="health.errorCount > 0">{{ health.errorCount | number }}</span>
            <span class="text-xs text-zinc-500">errors of {{ health.total | number }} events</span>
          </div>
          <div class="divide-y divide-zinc-100">
            <div *ngFor="let row of severityRows" class="flex items-center justify-between py-1.5">
              <span class="rounded px-1.5 py-0.5 text-[11px] font-medium" [ngClass]="severityBadge(row.severity)">{{ row.severity }}</span>
              <span class="text-xs tabular-nums text-zinc-600">{{ row.count | number }}</span>
            </div>
            <div *ngIf="severityRows.length === 0" class="py-4 text-center text-xs text-zinc-400">No log events in window.</div>
          </div>
        </div>
        <ng-template #noHealth>
          <div class="px-4 py-6 text-center text-xs text-zinc-400">System log health is unavailable.</div>
        </ng-template>
      </div>

    </div>
  </ng-container>
</div>
